<!-- 医疗案例 -->
<template>
  <div class="case">
    <h4 class="current">
      您的位置：<router-link to="/home">首页 </router-link> &gt;产品与方案 &gt; 医院全成本核算解决方案
    </h4>
    <div class="article">
      <h5>医院全成本核算解决方案</h5>

      <img src="@/assets/conimg3-01.png" />
      <img src="@/assets/conimg3-02.png" />
      <img src="@/assets/conimg3-03.png" />
      <img src="@/assets/conimg3-04.png" />
      <img src="@/assets/conimg3-05.png" />
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {}
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
h4.current {
  display: block;
  height: 40px;
  line-height: 30px;
  background: url(../../../assets/currentbg.jpg) repeat-x bottom;
  color: #333;
}
h4.current a:hover {
  color: #e90000;
}
.article h5 {
  display: block;
  text-align: center;
  line-height: 60px;
  font-size: 30px;
  color: #333;
  margin-top: 40px;
}
.article h6 {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #888;
  margin-top: 5px;
  margin-bottom: 30px;
}
.smalltit {
  display: block;
  height: 55px;
  line-height: 55px;
  margin-top: 20px;
  padding-left: 35px;
  background: url(../../../assets/ico01.png) no-repeat left center;
  font-size: 22px;
  color: #e60212;
}
.intro p {
  line-height: 30px;
}
.intro img {
  display: block;
  margin: 0 auto;
}
.article img {
  //margin: 0 auto;
  display: block;
  margin-top: 15px;
}
.article p {
  margin-top: 15px;
  line-height: 30px;
  margin: 15px 0;
}
.boldblack {
  color: #333;
  font-weight: bold;
}
.boldred {
  color: #f00;
  font-weight: bold;
}
.font18 {
  font-size: 18px;
}
</style>
